import { take } from 'rxjs/operators'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Params } from '@angular/router'
import { VinculoInstituicaoModel } from '@shared/models/backend'
import { Page } from '@shared/models'

@Injectable({
  providedIn: 'root',
})
export class VinculoInstituicaoService {
  constructor(private http: HttpClient) {}

  loadVinculoInstituicaoList(currentFilter: Params, pageNumber: number, pageSize: number) {
    return this.http
      .get<Page<VinculoInstituicaoModel>>('/api/vinculo-instituicao/list', {
        params: this.buildParams({ currentFilter, pageNumber, pageSize }),
      })
      .pipe(take(1))
  }

  removerVinculoInstituicao(vinculoInstituicaoId: number) {
    return this.http.delete(`/api/vinculo-instituicao/${vinculoInstituicaoId}`).pipe(take(1))
  }

  private buildParams(filter) {
    let params = new HttpParams()
    return params.append('size', filter.pageSize).append('page', filter.pageNumber).appendAll(filter.currentFilter)
  }
}
